const CONTRACT_PAYMENT_MODELS = {
  //getContractPaymentModels
  CONTRACT_PAYMENT_MODELS_ALL: 'CONTRACT_PAYMENT_MODELS_ALL',
  //getPaymentCodeFromRoot
  PAYMENT_CODE: 'PAYMENT_CODE',
  //getContractCooperationTypes
  CONTRACT_COOPERATION_TYPES: 'CONTRACT_COOPERATION_TYPES',
  //getPropertyTypesFromRoot
  PROPERTY_TYPES: 'PROPERTY_TYPES',
  //getContractCancellationExpenses
  CONTRACT_PAYMENT_CANCELLATION_EXPENSES: 'CONTRACT_PAYMENT_CANCELLATION_EXPENSES',
};

export default CONTRACT_PAYMENT_MODELS;
